import config from '@/api/config'

let createBookong = '/booking/create'

export default {
    createBooking: {
        url: function() {
            return config.baseUrl + config.version2 + createBookong
        }
    },
}